// 引入 polyfill 确保移动端浏览器兼容性
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import 'amfe-flexible'
import '../src/assets/font/font.css'
import 'animate.css'
import '@/assets/style.css'
import '@/style/common.less'
import 'swiper/css/swiper.css'
// import Nprogress from 'nprogress'
import 'nprogress/nprogress.css'
// import axios from 'axios'
import moment from 'moment'
import VueRouter from 'vue-router'
import xcUtils from './utils/xcUtils'
import curUtils from './utils/curUtils'
import chnEngStatusCode from './utils/chnEngStatusCode'
import logger from './utils/logger'
import raceSchedule from './components/partnerCom/raceSchedule.vue'
import toolCom from './components/partnerCom/toolCom.vue'
import http from './http/request'
// 拖拽拼图校验
import puzzleVerification from 'vue-puzzle-verification'
import cebsbLoading from '@/components/cebsbLoading/index.js'
// import i18n from '@/locale'
import info from './utils/infoData'
import customConfirm from './components/customConfirm.vue'
import TitleBar from '@/components/TitleBar.vue'
import VueI18n from 'vue-i18n'
import eleLocale from 'element-ui/lib/locale'
import eleEnLang from 'element-ui/lib/locale/lang/en'
import eleZhLang from 'element-ui/lib/locale/lang/zh-CN'
import env from './http/env'

// 添加调试信息（自动根据环境判断）
logger.debug('Main', '开始加载应用...')
logger.debug('Main', 'User Agent:', navigator.userAgent)
logger.debug('Main', 'Vue 版本:', Vue.version)

Vue.use(VueI18n)
Vue.use(cebsbLoading)
Vue.prototype.$xcUtils = xcUtils
Vue.prototype.$curUtils = curUtils
Vue.prototype.$chnEngStatusCode = chnEngStatusCode
Vue.prototype.$http = http
Vue.prototype.$info = info
Vue.prototype.$env = env
Vue.prototype.$log = logger // 挂载日志工具到 Vue 原型
moment.locale('en-US')
Vue.prototype.$moment = moment
Vue.config.productionTip = false
Vue.use(puzzleVerification)
Vue.component('raceSchedule', raceSchedule)
Vue.component('toolCom', toolCom)
Vue.component('customConfirm', customConfirm)
Vue.component('TitleBar', TitleBar)

// 安全获取 localStorage
function safeGetLocalStorage (key, defaultValue) {
  try {
    return localStorage.getItem(key) || defaultValue
  } catch (e) {
    logger.warn('[Main] localStorage 不可用:', e)
    return defaultValue
  }
}

const i18n = new VueI18n({
  locale: safeGetLocalStorage('locale', 'EN'), // 默认英文，已保存的语言偏好优先
  messages: {
    ZH: Object.assign({}, require('../src/i18n/lan/zh'), eleZhLang), // 合并 Element UI 中文语言包
    EN: Object.assign({}, require('../src/i18n/lan/en'), eleEnLang) // 合并 Element UI 英文语言包
  }
})
// Element UI 内置文案（分页、日期选择器、空数据等）跟随 vue-i18n 语言切换
eleLocale.i18n((key, value) => i18n.t(key, value))
logger.debug('Main', 'i18n 初始化完成')

// 添加错误处理，防止白屏
logger.debug('Main', '开始初始化 Vue 实例...')

// 确保 DOM 已准备好
function initVue () {
  const appEl = document.getElementById('app')
  if (!appEl) {
    logger.error('[Main] 找不到 #app 元素')
    setTimeout(initVue, 100)
    return
  }

  try {
    logger.debug('Main', '创建 Vue 实例...')
    const vueInstance = new Vue({
      router,
      store,
      i18n,
      render: h => h(App),
      errorCaptured: (err, vm, info) => {
        logger.error('[Main] Vue 错误捕获:', err, info)
        // 不阻止错误传播，但记录日志
        return false
      },
      mounted () {
        logger.debug('Main', 'Vue 实例已挂载')
        // 隐藏加载提示
        const loadingTip = document.getElementById('loading-tip')
        if (loadingTip) {
          loadingTip.style.display = 'none'
        }
      }
    })

    vueInstance.$mount('#app')
    logger.debug('Main', 'Vue 应用挂载成功')
  } catch (error) {
    logger.error('[Main] Vue 初始化失败:', error)
    logger.error('[Main] 错误堆栈:', error.stack)
    // 显示错误提示
    const appEl = document.getElementById('app')
    if (appEl) {
      appEl.innerHTML = `
        <div style="padding: 20px; text-align: center; color: white; background: rgba(0,0,0,0.8); border-radius: 8px; margin: 20px;">
          <h2>页面加载失败</h2>
          <p style="color: #f56c6c;">${error.message || '未知错误'}</p>
          <p style="font-size: 12px; color: #999; margin-top: 20px;">请检查控制台获取更多信息</p>
          <p style="font-size: 10px; color: #666; margin-top: 10px;">错误类型: ${error.name || 'Error'}</p>
        </div>
      `
    }
  }
}

// 等待 DOM 加载完成
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initVue)
} else {
  initVue()
}

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
